
import React, { useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';
import { useCart } from '../context/CartContext';

const StripeReturn: React.FC = () => {
    const isSuccess = window.location.pathname === '/success';
    const isCancel = window.location.pathname === '/cancel';
    const navigate = useNavigate();
    const { clearCart, openCart } = useCart();

    // Use a ref to ensure we only clear once per mount
    const hasCleared = useRef(false);

    useEffect(() => {
        if (isSuccess && !hasCleared.current) {
            clearCart();
            hasCleared.current = true;
        }
    }, [isSuccess, clearCart]);

    if (isSuccess) {
        return (
            <div className="min-h-screen bg-gray-50 pt-24 pb-20 flex items-center justify-center p-4">
                <div className="max-w-md w-full bg-white p-10 rounded-2xl shadow-xl text-center">
                    <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                        <CheckCircle size={40} />
                    </div>
                    <h1 className="font-heading font-bold text-3xl uppercase tracking-wide mb-4">Payment Successful!</h1>
                    <p className="font-body text-gray-600 mb-6">
                        Thank you for your order. We've received your payment and will send a confirmation email shortly.
                    </p>
                    <Link to="/" className="block w-full bg-black text-white py-4 font-heading font-bold uppercase tracking-widest hover:bg-gray-800 transition-colors">
                        Return to Shop
                    </Link>
                </div>
            </div>
        );
    }

    if (isCancel) {
        return (
            <div className="min-h-screen bg-gray-50 pt-24 pb-20 flex items-center justify-center p-4">
                <div className="max-w-md w-full bg-white p-10 rounded-2xl shadow-xl text-center">
                     <div className="w-20 h-20 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                        <XCircle size={40} />
                    </div>
                    <h1 className="font-heading font-bold text-3xl uppercase tracking-wide mb-4">Payment Canceled</h1>
                    <p className="font-body text-gray-600 mb-8">
                        Your payment was canceled. No charges were made.
                    </p>
                    <button
                        onClick={() => { navigate('/'); openCart(); }}
                        className="block w-full bg-black text-white py-4 font-heading font-bold uppercase tracking-widest hover:bg-gray-800 transition-colors"
                    >
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen pt-24 flex justify-center">
           <p>Invalid Return URL</p>
        </div>
    );
};

export default StripeReturn;
